import OrderInfo from "./orderInfo/index.vue";
import SectionRight from "./sectionRight/test.vue";
// import SectionRight from "./sectionRight/index.vue";
import useApi from "@/api/useApi";

const baseData = {
  caseId: null,
  list: {},
  order_no: "",
  event_status: ""
};
const funcs = {};

funcs.getCollectionDetail = async function() {
  // console.log(this.caseId, "this.caseId");
  const { getCollectionDetail } = useApi();
  const res = await getCollectionDetail({ id: this.caseId });
  this.list = res.data.data;
  this.order_no = res.data.data.order_no;
  // console.log(this.list, "111-222222221");

  switch (res.data.data.event_status) {
    case 0:
      this.event_status = "待催收";
      break;
    case 1:
      this.event_status = "跟进中";
      break;
    case 2:
      this.event_status = "待起诉";
      break;
    case 3:
      this.event_status = "已起诉";
      break;
    case 4:
      this.event_status = "已立案";
      break;
    case 5:
      this.event_status = "已完结 ";
      break;
    default:
      break;
  }
};

export default {
  name: "CaseManage",
  props: {},
  components: {
    OrderInfo,
    SectionRight
  },
  data() {
    return { ...baseData };
  },
  methods: { ...funcs },
  created() {
    this.caseId = this.$route.query.id;
    this.getCollectionDetail();
  }
};



// WEBPACK FOOTER //
// ./src/views/collection/manage/contact.js